var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { View } from "ol";
import { Map } from "ol";
import { Switchboard } from "../events";
import { EPSG } from "../projection";
import { Maybe, None, Some } from "../misc/option";
import { LayerBox } from "../ui/layer";
import { ReadyMessage } from "../messages";
import { WaitFor } from "../misc/decorators";
import $ from 'jquery';
export class ExtendedMap extends Map {
    constructor(options) {
        super(options);
        this.rest_layers = [];
        this.projection = None.instance();
        this.is_loaded = false;
        this.receiver = Switchboard.get_receiver("MOVEMENT");
        this.strategy = options.strategy;
        this.strategy.create_layers().then(layers => {
            this.rest_layers = layers;
            this.projection = this.base_layer.map(sl => sl.projection);
            this.layer_box = new LayerBox(this.rest_layers);
            layers.forEach(l => {
                l.layers.map(r => {
                    try {
                        this.addLayer(r);
                    }
                    catch (_a) {
                        throw new Error("Failed to add layer.");
                    }
                });
            });
            try {
                this.create_view(this.strategy.min_resolution, this.strategy.max_resolution);
            }
            catch (_a) {
                throw new Error("Could not create view.");
            }
            this.updateSize();
            this.initialize_handlers();
            this.changed();
            this.is_loaded = true;
        });
        this.receiver.on("center", (maybe_coord) => {
            maybe_coord.map((c) => this.view.animate({ center: c, duration: 200 }));
        });
    }
    get base_layer() {
        const bases = this.rest_layers.filter(l => l.is_base);
        if (bases.length === 0)
            return None.instance();
        return new Some(bases[0]);
    }
    get view() { return this.getView(); }
    get viewport() { return this.getViewport(); }
    get size() { return this.getSize(); }
    getStrategy() { return JSON.parse(JSON.stringify(this.strategy)); }
    create_view(min_res, max_res) {
        var _a, _b, _c;
        const min_res_divisor = (_c = (_b = (_a = this.getStrategy().config) === null || _a === void 0 ? void 0 : _a.Zoom) === null || _b === void 0 ? void 0 : _b.MinResolutionDivisor) !== null && _c !== void 0 ? _c : 1;
        this.setView(new View({
            projection: this.projection.unwrapOr(EPSG(4426)),
            zoom: 12,
            minResolution: min_res / min_res_divisor,
            maxResolution: max_res
        }));
        this.base_layer
            .flatmap(bl => bl.raw)
            .flatmap(l => Maybe(l.getExtent()))
            .map(e => this.view.fit(e, { size: this.size, padding: [80, 80, 80, 80] }));
    }
    initialize_handlers() {
        this.viewport.addEventListener('mouseout', (e) => $('#help-message').addClass('hidden'));
    }
    get_highest_z() {
        const layers = this.getLayers().getArray();
        return Math.max(...layers.map(l => l.getZIndex())) || 0;
    }
    async loaded() {
        while (!this.is_loaded) {
            await new Promise(res => setTimeout(res, 20));
        }
        if (!$('body').hasClass('loaded')) {
            $('body').addClass('loaded');
            $("#loader").addClass("hidden");
        }
        return this;
    }
    async add_client_layers(...client_layers) {
        await this.loaded();
        for (let layer of client_layers) {
            const z = this.get_highest_z();
            layer.projection = this.projection.unwrapOr(EPSG(3857));
            layer.raw.setZIndex(z + 1);
            this.addLayer(layer.raw);
        }
    }
    async add_selection_layer(selection_layer) {
        await this.loaded();
        const z = this.get_highest_z();
        selection_layer.raw.setZIndex(z + 1);
        selection_layer.projection = this.projection.unwrapOr(EPSG(4426));
        this.addLayer(selection_layer.raw);
    }
    get_features_at_pixel(pixel) {
        let hit = this.hasFeatureAtPixel(pixel);
        let features = [];
        if (hit) {
            this.forEachFeatureAtPixel(pixel, (feature, layer) => {
                features.push([feature, layer]);
            });
        }
        return features;
    }
    ready() {
        ReadyMessage.send();
    }
    add_layerbox_components(...components) {
        var _a;
        (_a = this.layer_box) === null || _a === void 0 ? void 0 : _a.add_components(...components);
    }
}
__decorate([
    WaitFor()
], ExtendedMap.prototype, "loaded", null);
